export default "__VITE_ASSET__VTHm7h4A__"